import { createContainer } from 'unstated-next';
import * as types from './types';
import { useState } from 'react';

export const EditContainer = createContainer(() => {
  const [selectedTrack, setSelectedTrack] = useState(0);
  const [selectedTool, setSelectedTool] = useState(types.Tool.Paint);
  const [verticalZoom, setVerticalZoom] = useState(2);

  return {
    selectedTrack, setSelectedTrack,
    selectedTool, setSelectedTool,
    verticalZoom, setVerticalZoom
  };
});
